import * as React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { Select, ValueType } from 'components/spaceKit';

type ActionSelectProps = {
    value: string;
    option: any;
    inheritClear?: boolean;
    isClearable?: boolean;
    options: Array<{ [key: string]: any }>;
    defaultValue?: ValueType;
    isSearchable?: boolean;
    isMulti?: boolean;
    isDisabled?: boolean;
    name?: string;
    isLoading?: boolean;
    placeholder?: string;
    valueKey?: string;
    labelKey?: string;
    clearValue?: { [key: string]: any };
};

const ActionSelect: React.FC<ActionSelectProps> = ({
    value,
    option,
    inheritClear,
    isClearable,
    options,
    defaultValue,
    isSearchable,
    isMulti,
    isDisabled,
    name,
    isLoading,
    placeholder,
    valueKey,
    labelKey,
    clearValue,
}) => (
    <Select
        value={option[value]}
        inheritClear={inheritClear}
        isClearable={isClearable}
        options={options}
        defaultValue={defaultValue}
        isSearchable={isSearchable}
        isMulti={isMulti}
        isDisabled={isDisabled}
        name={name}
        isLoading={isLoading}
        placeholder={placeholder}
        valueKey={valueKey}
        labelKey={labelKey}
        clearValue={clearValue}
        onChange={action(
            (selection: { id: string; value: string }) => (option[value] = selection.value)
        )}
    />
);

ActionSelect.displayName = 'ActionSelect';
export default observer(ActionSelect);
